import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Getdata } from "../../helpers/api.service";
import Breadcrums from "../../Components/common/Breadcrums";

const ViewProjects = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/project/show/${process.env.REACT_APP_SUBDOMAIN}${params?.title}`
      //   { name: "dffdfdfd"}
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
          if (res.data.image && res.data.image.length > 0) {
            setSelectedImage(res.data.image[0]); // Set first image initially
          }
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="max-w-7xl mx-auto text-left mb-5">
      <div className="text-start max-w-7xl mx-auto font-medium  mt-10 mb-5">
        <Breadcrums
          pages={[{ title: "Projects", link: "education" }, { title: params?.title }]}
        />
      </div>

      <div className=" mx-auto">
        {selectedImage && (
          <div className="mb-4 w-full h-[220px] sm:h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden rounded-lg">
            <img
              src={selectedImage}
              alt="Selected"
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="flex overflow-x-auto space-x-2 mb-4">
          {data.image &&
            data.image.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Thumbnail ${idx}`}
                onClick={() => setSelectedImage(img)}
                className={`w-28 h-20 object-cover rounded-[10px] cursor-pointer border-2 ${selectedImage === img
                  ? "border-blue-500"
                  : "border-transparent"
                  }`}
              />
            ))}
        </div>
        <div className="border-[#EAEAEA] bg-[#F9F5FF] border-[1px] rounded-xl p-4 relative flex justify-between text-gray-800   mx-auto">
          <div>
            <h3 className="text-2xl font-bold mb-2">{data.title}</h3>
            <h3 className="text-sm font-normal mb-2">
              People Involved :{" "}
              <span className="text-sm font-bold">{data.people_involved}</span>
            </h3>
            <h3 className="text-sm font-normal mb-2">{data.description}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ViewProjects
